export const ALLOWED_BRANDS = ["normal", "chicago"];
export const DEFAULT_BRAND = "normal";

const normalizeBrand = (brand) =>
  typeof brand === "string" ? brand.trim().toLowerCase() : "";

export const getValidatedBrand = (brand) => {
  const normalizedBrand = normalizeBrand(brand);
  return ALLOWED_BRANDS.includes(normalizedBrand)
    ? normalizedBrand
    : DEFAULT_BRAND;
};

export const getBrandFromUrl = (search = window.location.search) => {
  const queryParams = new URLSearchParams(search);
  return getValidatedBrand(queryParams.get("brand"));
};

export const applyActiveBrand = (search = window.location.search) => {
  const activeBrand = getBrandFromUrl(search);
  document.documentElement.dataset.brand = activeBrand;
  return activeBrand;
};
